<template>
    <main class="freedom_bank phone screen home-screen">
        <div class="status-bar">
            <div class="search-pill">
                <span class="search-icon"></span>
                <span>Байланысты табу...</span>
            </div>
            <div class="profile-badge"></div>
        </div>

        <section class="stories">
            <article class="story-card active">
                <div class="story-visual story-visual-1"></div>
                <p>Сақ болыңыз</p>
            </article>
            <article class="story-card">
                <div class="story-visual story-visual-2"></div>
                <p>Ықтимал табысты есептеу</p>
            </article>
            <article class="story-card">
                <div class="story-visual story-visual-3"></div>
                <p>Қызметтердің негізгі тарифтеріндегі өзгерістер</p>
            </article>
            <article class="story-card">
                <div class="story-visual story-visual-4"></div>
                <p>Біздің ресми беттеріміз</p>
            </article>
            <article class="story-card">
                <div class="story-visual story-visual-5"></div>
                <p>Жеке мәліметтерді жаңарту</p>
            </article>
        </section>

        <section class="balance">
            <div class="balance-row">
                <h1>Менің ақшам</h1>
                <div class="balance-total">{{ balance.main }}.<span>{{ balance.digits }} KZT</span></div>
            </div>
            <div class="balance-track">
                <div class="balance-fill"></div>
            </div>
            <div class="balance-caption">USD</div>
        </section>

        <section class="tabs">
            <button class="tab active" type="button">Банк</button>
            <button class="tab" type="button">Депозиттер</button>
            <button class="tab" type="button">Брокер</button>
        </section>

        <section class="bank-block">
            <div class="section-heading">
                <h2>Freedom Bank KZ</h2>
                <span class="plus-chip">+</span>
            </div>

            <article class="bank-card" @click="toTransactions">
                <div class="bank-card-top">
                    <h3 class="bank-card-title">Мультивалютная депозитная карта</h3>
                    <div class="bank-card-side">
                        <p class="bank-card-amount">{{ $store.state.data.home.balance }} ₸</p>
                        <ul class="currency-list">
                            <li><span class="currency-value">0.01</span> <span class="currency-code">KZT</span></li>
                            <li><span class="currency-value">{{ $store.state.data.home.balance_usd }}</span> <span class="currency-code">USD</span></li>
                            <li><span class="currency-value">0.00</span> <span class="currency-code">EUR</span></li>
                            <li><span class="currency-value">0.00</span> <span class="currency-code">RUB</span></li>
                            <li><span class="currency-value">0.00</span> <span class="currency-code">TRY</span></li>
                            <li><span class="currency-value">0.00</span> <span class="currency-code">CNY</span></li>
                            <li><span class="currency-value">0.00</span> <span class="currency-code">AED</span></li>
                        </ul>
                    </div>
                </div>
                <div class="bank-card-bottom">
                    <span class="bank-card-id">•• {{ $store.state.data.home.card_number }}</span>
                    <img class="bank-card-brand" src="../../assets/freedom/img/ma_symbol.svg" alt="Mastercard" />
                </div>
            </article>

            <article class="promo-card">
                <div class="promo-copy">
                    <p class="promo-eyebrow">шот ашыңыз</p>
                    <p>Ресейге сапарлар үшін</p>
                    <button type="button">Толығырақ</button>
                </div>
                <div class="promo-visual"></div>
            </article>
        </section>

        <nav class="bottom-nav">
            <span class="nav-item nav-products active">
                <span class="nav-icon" aria-hidden="true"></span>
                <span class="nav-label">Өнімдер</span>
            </span>
            <span class="nav-item nav-stats">
                <span class="nav-icon" aria-hidden="true"></span>
                <span class="nav-label">Статистика</span>
            </span>
            <span class="nav-item nav-transfers">
                <span class="nav-icon" aria-hidden="true"></span>
                <span class="nav-label">Аударымдар</span>
            </span>
            <span class="nav-item nav-contacts">
                <span class="nav-icon" aria-hidden="true"></span>
                <span class="nav-label">Байланыстар</span>
            </span>
        </nav>
    </main>

</template>

<script>
    export default {
    	head: {
    		meta: [
                {
                    name: 'application-name', 
                    content: 'Freedom'
                },
                {
                    name: 'apple-mobile-web-app-title', 
                    content: 'Freedom'
                },
                {
                    name: 'author', 
                    content: 'Freedom'
                }
            ],
            link: [
            	{
                    rel: 'apple-touch-icon',
                    href: require('../../assets/freedom/favicon/180x180.png')
                },
                {
                    rel: 'shortcut icon',
                    href: require('../../assets/freedom/favicon/32x32.png'),
                    sizes: '32x32',
                    type: 'image/png'
                },
            ]
    	},
        data() {
            return {
                balance: {
                    main: 0,
                    digits: 0
                }
            }
        },
        methods: {
            toTransactions() {
            	this.$router.replace({
                    name: 'FreedomTransactions',
                    params: { 0: `/${this.$route.path}` },
                    replace: true,
                })
            }
        },
        beforeMount () {
            var balance = this.$store.state.data.home.balance.split('.')

            this.balance = {
                main: balance[0],
                digits: balance[1]
            }
        }
    }
</script>
